import { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell, WidthType, BorderStyle, convertInchesToTwip } from "docx";
import { saveAs } from "file-saver";

export const wordRPT232 = (dataReport, setLoading) => {
    setLoading(true);
    const font = {
        size: {
            p: 28,
            tbHeader: 28,
            tbbody: 28,
            normal: 28,
            num: 28,
        },
        SarabunPSK: "TH SarabunPSK",
    };
    const cellBorder = {
        noBorder: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
        line: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
    };
    const table1 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(15),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        margins: { top: convertInchesToTwip(0.2), bottom: convertInchesToTwip(0.2) },
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                text: "สัญญาจ้างเลขที่ " + dataReport.contractNO,
                                                                font: font.SarabunPSK,
                                                                size: font.size.tbHeader,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                text: dataReport.routeInfo == null ? "เส้นทางที่ " : "เส้นทางที่ " + dataReport.routeInfo,
                                                                size: font.size.tbHeader,
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    // Begin Table 2
    const table2 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        margins: { bottom: convertInchesToTwip(0.3) },
                        rowSpan: 2,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "รายการ",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        columnSpan: 2,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "จำนวนเงิน/บาท",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(2.5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ครั้งนี้",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(2.5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ถึงครั้งนี้",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "รวมค่างานงวดนี้ (รวมภาษีมูลค่าเพิ่ม)",
                                        bold: true,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(2.5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "right",
                                children: [
                                    new TextRun({
                                        text: dataReport.deliverAmount,
                                        bold: true,
                                        size: font.size.num,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(2.5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "right",
                                children: [
                                    new TextRun({
                                        text: dataReport.accrueAmount,
                                        bold: true,
                                        size: font.size.num,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    //push row body

    for (let i = 0; i < 5; i++) {
        table2.root.push(
            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "",
                                        bold: true,
                                        size: font.size.tbbody,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(2.5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "",
                                        bold: true,
                                        size: font.size.tbbody,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(2.5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "",
                                        bold: true,
                                        size: font.size.tbbody,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            })
        );

        if (i === 4) {
            table2.root.push(
                new TableRow({
                    children: [
                        new TableCell({
                            width: {
                                size: convertInchesToTwip(5),
                                type: WidthType.DXA,
                            },
                            children: [
                                new Paragraph({
                                    alignment: "center",
                                    children: [
                                        new TextRun({
                                            text: "ยอดรวม (รวมภาษีมูลค่าเพิ่ม)",
                                            bold: true,
                                            size: font.size.tbbody,
                                            font: font.SarabunPSK,
                                        }),
                                    ],
                                }),
                            ],
                        }),
                        new TableCell({
                            width: {
                                size: convertInchesToTwip(2.5),
                                type: WidthType.DXA,
                            },
                            children: [
                                new Paragraph({
                                    alignment: "right",
                                    children: [
                                        new TextRun({
                                            text: dataReport.deliverAmount,
                                            bold: true,
                                            size: font.size.num,
                                            font: font.SarabunPSK,
                                        }),
                                    ],
                                }),
                            ],
                        }),
                        new TableCell({
                            width: {
                                size: convertInchesToTwip(2.5),
                                type: WidthType.DXA,
                            },
                            children: [
                                new Paragraph({
                                    alignment: "right",
                                    children: [
                                        new TextRun({
                                            text: dataReport.accrueAmount,
                                            bold: true,
                                            size: font.size.num,
                                            font: font.SarabunPSK,
                                        }),
                                    ],
                                }),
                            ],
                        }),
                    ],
                })
            );
        }
    }

    const space = new Paragraph({
        children: [],
    });

    const table3 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        margins: { top: convertInchesToTwip(0.2), bottom: convertInchesToTwip(0.5) },
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        margins: { top: convertInchesToTwip(0.2), bottom: convertInchesToTwip(0.5) },
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "เสนอขออนุมัติโดยผู้รับจ้าง",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ลงนาม ................................",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "( ................................ )",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "................................",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ผู้รับจ้าง",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const line = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        margins: { top: convertInchesToTwip(0.2) },
                        borders: cellBorder.line,
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                    new TableCell({
                        margins: { top: convertInchesToTwip(0.2) },
                        borders: cellBorder.line,
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                ],
            }),
        ],
    });

    const p1 = new Paragraph({
        alignment: "left",
        children: [
            new TextRun({
                text: "เรียน",
                size: font.size.p,
                font: font.SarabunPSK,
            }),
            new TextRun({
                text: "    คณะกรรมการตรวจรับพัสดุ",
                size: font.size.p,
                font: font.SarabunPSK,
            }),
        ],
    });

    const p2 = new Paragraph({
        alignment: "left",
        children: [
            new TextRun({
                text: "         ",
                size: font.size.p,
            }),
            new TextRun({
                text: "ผู้ควบคุมงานได้ตรวจสอบงานก่อสร้างแล้ว ขอรับรองว่างานแล้วเสร็จถูกต้องตามเงื่อนไขสัญญาจ้างเห็นสมควรทำการตรวจรับมอบงานดังกล่าว ต่อไป",
                size: font.size.p,
                font: font.SarabunPSK,
            }),
        ],
    });

    const table4 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        margins: { top: convertInchesToTwip(0.2), bottom: convertInchesToTwip(0.5) },
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "เสนอขออนุมัติโดยผู้รับจ้าง",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ลงนาม ................................",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "( ................................ )",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "................................",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ผู้ควบคุมงาน",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const doc = new Document({
        sections: [
            {
                children: [table1, space, table2, space, table3, line, space, p1, p2, table4],
            },
        ],
    });

    Packer.toBlob(doc).then((blob) => {
        setLoading(false);
        saveAs(blob, "PRT232.docx");
    });
};
